import { useQuery } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";
import { threadsApi } from "@/lib/humhub-api/threads";
import { threadKeys } from "@/lib/queryKeys/threadKeys";

export const useThreadUnreadSummary = (
  options: { enabled?: boolean; poll?: boolean } = {},
) => {
  const auth = useAuth();
  const authReady =
    !auth.isLoading && auth.isAuthenticated && Boolean(auth.user);
  return useQuery({
    queryKey: threadKeys.unreadSummary(),
    queryFn: ({ signal }) => threadsApi.getUnreadSummary(signal),
    enabled: authReady && (options.enabled ?? true),
    staleTime: 30_000,
    refetchInterval: options.poll === false ? false : 60_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    retry: false,
  });
};
